import React from 'react';
// import PropTypes from 'prop-types';
import classNames from 'classnames';
import defaultTheme from '../../themes/default';

const map = tag => {
  switch (tag) {
    case 'a':
    case 'input':
      return tag;

    default:
      return 'button';
  }
};

const BaseButton = React.forwardRef(
  ({ tag, variant, appearance, children, className, ...otherProps }, ref) => {
    const Tag = map(tag);
    return (
      <Tag
        ref={ref}
        className={classNames(
          defaultTheme.button.base,
          defaultTheme.button[variant][appearance],
          className,
        )}
        {...otherProps}
        children={tag === 'input' ? null : children}
      />
    );
  },
);

// haven't include react-router Link
// use <Link><Button/></Link> when needed
// BaseButton.propTyps = {
//   tag: PropTypes.oneOf(['button', 'a', 'input']),
// };

export default BaseButton;
